import { render, staticRenderFns } from "./LatestEntriesWidget.vue?vue&type=template&id=7c746896"
import script from "./LatestEntriesWidget.vue?vue&type=script&lang=js"
export * from "./LatestEntriesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports